import { render, staticRenderFns } from "./GastoDetalleWebApp.vue?vue&type=template&id=469131ce&"
import script from "./GastoDetalleWebApp.vue?vue&type=script&lang=js&"
export * from "./GastoDetalleWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports